import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { CHRISTMAS_SEASON_YEAR } from '../utils/christmasYear'

const Home: React.FC = () => {
  const { user } = useAuth()
  const defaultListLink = `/wishlist/${user?.id}` 

  return (
    <div className="container">
      <div className="hero" style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--primary-color)' }}>
          Welcome to the Christmas App, {CHRISTMAS_SEASON_YEAR} edition
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '2rem' }}>
          Create and share your Christmas wishes with the family
        </p>
        <Link to={defaultListLink} className="btn btn-primary" style={{ fontSize: '1.1rem', padding: '0.75rem 2rem' }}>
          Get Started
        </Link>
        <p style={{ marginTop: '2.5rem', color: '#555', fontStyle: 'italic' }}>
          with purrs, Koko &amp; Lbop 🐾
        </p>
      </div>
    </div>
  )
}

export default Home